import { back, hamburger } from "@/assets/images/index";
import { useDesignMaxTheme } from "@/packages";
import { useToggleState } from "@/shared/client";
import { FONT } from "@/styles";
import { Box, Center, IconButton, Menu } from "@chakra-ui/react";
import { type PropsWithChildren } from "react";

export const ToggleMenu = ({ children }: PropsWithChildren) => {
    const [isMenu, setIsMenu] = useToggleState();
    const { COLORS, MEDIAS } = useDesignMaxTheme();
    const { isLaptop, isMobile } = MEDIAS();

    const contentPCPaddingRight = isLaptop ? "88px" : "256px";
    const contentPCPadding = isLaptop ? "64px 48px" : "80px 80px 80px 24px";
    const contentPCHeight = isLaptop ? "528PX" : "792px";
    return (
        <Center
            sx={{
                "& > button": {
                    position: "relative",
                    zIndex: 3,
                    ...FONT("cormorant", 16, 700),
                    transition: "1s cubic-bezier(0.215, 0.61, 0.355, 1)",
                    color: COLORS.white,
                },
            }}
        >
            <Menu>
                <Box
                    className="hamburger_menu"
                    as={IconButton}
                    borderRadius="none"
                    w="40px"
                    h="24px"
                    color={!isMenu ? `${COLORS.gray[400]} ! important` : "white"}
                    onClick={() => setIsMenu((prev) => !prev)}
                    background={
                        !isMenu ? `url(${hamburger})no-repeat center/cover` : `url(${back})no-repeat center/cover`
                    }
                    sx={{
                        _hover: {
                            background: !isMenu
                                ? `url(${hamburger})no-repeat center/cover`
                                : `url(${back})no-repeat center/cover`,
                        },
                    }}
                />
            </Menu>
            <Box
                position="absolute"
                w="100%"
                h="100vh"
                top="-100vh"
                left="0"
                boxSizing="border-box"
                transition="1s cubic-bezier(0.215, 0.61, 0.355, 1)"
                bgColor={COLORS.transparent.b80}
                p="100px 0"
                zIndex="2"
                className={isMenu ? "on" : "off"}
                sx={{
                    "&.on": {
                        top: 0,
                    },
                }}
            >
                <Box
                    position="absolute"
                    w="100%"
                    h={isMobile ? "calc(100% - 60px)" : contentPCHeight}
                    top={isMobile ? "60px" : "50%"}
                    left="50%"
                    transform={isMobile ? "translateX(-50%)" : "translate(-50%, -50%)"}
                    paddingRight={isMobile ? "0" : contentPCPaddingRight}
                >
                    <Box
                        position="relative"
                        justifyContent="flex-end"
                        display="flex"
                        w="100%"
                        height="100%"
                        padding={isMobile ? "24px" : contentPCPadding}
                        borderRightRadius={isMobile ? "none" : "16px"}
                        background="white"
                    >
                        {children}
                    </Box>
                </Box>
            </Box>
        </Center>
    );
};
